import * as React from 'react';

import Field from 'components/Field';
import Image from 'components/Image';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import MediaObject from 'components/MediaObject';
// @ts-ignore
import Radio from 'components/Radio';
import Text from 'components/Text';

import AnnouncementImage from 'assets/images/SplitComposer/announcement.svg';
import UrgentAnnouncementImage from 'assets/images/SplitComposer/urgent.svg';

import './styles/AdminNewAutoMessageComposeUrgency.scss';

type Props = {
  handleIsUrgentMessageChange: (isUrgent: boolean) => void;
  isUrgent: boolean;
};

export default function AdminNewAutoMessageComposeUrgency(props: Props) {
  const { isUrgent } = props;

  const announcementLabel = (
    <MediaObject gutter="xsmall">
      <Image src={AnnouncementImage} width="16" height="16" />
      <Text>Send normally</Text>
    </MediaObject>
  );
  const urgentAnnounceLabel = (
    <MediaObject gutter="xsmall">
      <Image src={UrgentAnnouncementImage} width="16" height="16" />
      <div>
        <Text>Send as urgent message</Text>
      </div>
    </MediaObject>
  );

  return (
    <Field>
      <Radio
        label={announcementLabel}
        labelNote="Message will be sent based on recipients’ notification preferences."
        onChange={() => props.handleIsUrgentMessageChange(!isUrgent)}
        checked={!isUrgent}
      />
      <Radio
        label={urgentAnnounceLabel}
        labelNote="Message will be sent to all available devices, overriding opt-out preferences."
        customLabelNote={
          <Link
            className="AdminNewAutoMessageComposeUrgency-urgentLink"
            href={LinkConstants.URGENT_MESSAGING_HELP}
            target="_blank">
            Learn more
          </Link>
        }
        onChange={() => props.handleIsUrgentMessageChange(!isUrgent)}
        checked={isUrgent}
      />
    </Field>
  );
}
